module.exports = __webpack_public_path__ + "img/team_5.3d1597fe.jpg";